import {BaseApiTemplateService, Core2Config} from '../../shared';
import {FinancialItemMarketplaceContainerModel} from '../../../../../../models';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class FinancialItemMarketplaceBackOfficeService extends BaseApiTemplateService<FinancialItemMarketplaceContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/backoffice-ep/marketplace';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/backoffice-ep/marketplace';
    this.httpClient = http;
  }

}
